import React from 'react';
import { cn } from '../lib/cn';

/**
 * Table — Tabla estilo CRM: cabeceras en uppercase, filas hoverables,
 * separadores sutiles.
 *
 * Uso:
 *   <Table>
 *     <THead>
 *       <Tr>
 *         <Th>Nombre</Th>
 *         <Th>Email</Th>
 *         <Th align="right">Estado</Th>
 *       </Tr>
 *     </THead>
 *     <TBody>
 *       <Tr>
 *         <Td>Iban</Td>
 *         <Td>iban@grupolae.net</Td>
 *         <Td align="right"><Badge>Activo</Badge></Td>
 *       </Tr>
 *     </TBody>
 *   </Table>
 */
export const Table = ({ className, ...props }) => (
    <table className={cn('w-full border-collapse text-sm', className)} {...props} />
);

export const THead = ({ className, ...props }) => (
    <thead className={cn('', className)} {...props} />
);

export const TBody = ({ className, ...props }) => (
    <tbody className={className} {...props} />
);

export const Tr = ({ className, ...props }) => (
    <tr className={cn('border-b border-slate-100 last:border-0 hover:bg-slate-50/60 transition-colors', className)} {...props} />
);

export const Th = ({ align, className, ...props }) => (
    <th
        className={cn(
            'px-3.5 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-slate-500',
            'border-b border-slate-200 bg-slate-50/80',
            align === 'right' && 'text-right',
            align === 'center' && 'text-center',
            !align && 'text-left',
            className
        )}
        {...props}
    />
);

export const Td = ({ align, className, ...props }) => (
    <td
        className={cn(
            'px-3.5 py-3 text-slate-700',
            align === 'right' && 'text-right',
            align === 'center' && 'text-center',
            className
        )}
        {...props}
    />
);
